export default __webpack_public_path__ + "cd31bbbc40e0133249a2cd0ac00e9bf6.png";